import { render } from "./index.vue?vue&type=template&id=074777e2&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./style/transfer.scss?vue&type=style&index=0&id=074777e2&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=074777e2&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074777e2"]])

export default __exports__